import React, { useState } from "react";
import axios from 'axios';
import { Link, useNavigate } from "react-router-dom";

// Icons
import { MdDashboard } from "react-icons/md";
import { FaRegAddressBook } from "react-icons/fa";
import { VscAccount } from "react-icons/vsc";
import { IoIosBook } from "react-icons/io";
import { BiSupport } from "react-icons/bi";
import { CiMenuBurger } from "react-icons/ci";
import { FaArrowRight, FaAngleDown } from "react-icons/fa6";
import { CiSearch } from "react-icons/ci";
import { FaWhatsapp } from "react-icons/fa";
import { HiOutlineBellAlert } from "react-icons/hi2";
import { FaRegUser } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import { CgProfile } from "react-icons/cg";
import { IoSettingsOutline } from "react-icons/io5";
import { CiLogout } from "react-icons/ci";

// Components
import Dashboard from "../components/Dashbord/Geust/Dashboard";
import Courses from "../components/Dashbord/Geust/Courses";
import Assignment from "../components/Dashbord/Geust/Assignment";
import Account from "../components/Dashbord/Geust/Account";
import Support from "../components/Dashbord/Geust/Support";
import logo from "../assets/logo.png";
import Category from "../components/Dashbord/academy/Category";
import Evaluation from "../components/Dashbord/academy/Evaluation";
import Payment from "../components/Dashbord/payment/Payment";
import Book from "../components/Dashbord/academy/Book";
import Appointment from "../components/Dashbord/appointment/Appointment";

const Settings = () => <div>This is the Settings component</div>;
const Profile = () => <div>This is the Profile component</div>;
const PendingAssignments = () => <div>Pending Assignments</div>;
const SubmittedAssignments = () => <div>Submitted Assignments</div>;
const GradedAssignments = () => <div>Graded Assignments</div>;

const GuestDashboard = () => {
  const navigate = useNavigate();
  const [menu, setManu] = useState(true);
  const [active, setActive] = useState("dashboard");
  const [profileModal, setProfileModal] = useState(false);
  const [assignmentDropdown, setAssignmentDropdown] = useState(false);
  const [academyDropdown, setacademyDropdown] = useState(false);
  const [courseDropdown, setCourseDropdown] = useState(false);
  const user = JSON.parse(localStorage.getItem('user'));

  const renderComponent = () => {
    switch (active) {
      case "dashboard":
        return <Dashboard />;
        // course
      case "course":
        return <Courses />;
      case "assignment":
        return <Assignment />;
      case "pending":
        return <PendingAssignments />;
      case "submitted":
        return <SubmittedAssignments />;
      case "graded":
        return <GradedAssignments />;
      case "appointment":
        return <Appointment />;
      case "support":
        return <Support />;
      case "settings":
        return <Settings />;
      case "profile":
        return <Profile />;
        // academy
      case "category":
        return <Category />;
      case "evaluation":
        return <Evaluation />;
      case "book":
        return <Book />;
        // payment
      case "payment":
        return <Payment />;


      default:
        return <div>Select a component</div>;
    }
  };

  const handleLogout = async () => {
    try {
      await axios.post(`${import.meta.env.VITE_API_BASE_URL}/api/logout`, {}, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
    } catch (err) {
      console.warn('Server logout failed, but clearing local logout anyway');
    }
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/signin');
  };

  return (
    <div className="w-full min-h-screen flex gap-[2rem] bg-[#001E38] lg:p-[2rem] p-4 relative">
      {/* sidebar */}
      <div className={`w-[15rem] min-h-screen transition-all duration-300 ${menu ? "flex" : "hidden"} lg:static flex-col gap-4 absolute left-4 top-4 z-40 bg-[#00294B] rounded-md shadow-md`}>
        <div className="w-full flex items-center justify-center mt-8 border-b border-[#22BEFF33] pb-[1.5rem] relative">
          <Link to="/" className="flex justify-center items-center">
            <img src={logo} alt="Logo" className="w-[80%]" />
          </Link>
          <div className="absolute right-0 top-0 w-[1rem] h-[1rem] bg-white cursor-pointer lg:hidden block" onClick={() => setManu(false)}>
            <RxCross2 />
          </div>
        </div>

        <div className="mt-[1.5rem] p-4 flex flex-col gap-2">
          <span className={`flex items-center gap-2 text-[#e6eaec] py-3 px-4 rounded-md cursor-pointer ${active === "dashboard" ? "bg-[#22BEFF] text-black" : "hover:text-[#22BEFF]"}`} onClick={() => setActive("dashboard")}>
            <MdDashboard />
            Dashboard
          </span>

          

          {/* course with Dropdown */}
           <div>
            <span
              className={`flex items-center justify-between gap-2 text-[#e6eaec] py-3 px-4 rounded-md cursor-pointer ${["assignment", "pending", "submitted", "graded"].includes(active) ? "bg-[#22BEFF] text-black" : "hover:text-[#22BEFF]"}`}
              onClick={() => setCourseDropdown(!courseDropdown)}
            >
              <div className="flex items-center gap-2">
                <FaRegAddressBook />
                My Course
              </div>
              <FaAngleDown className={`transition-transform duration-300 ${courseDropdown ? "rotate-180" : ""}`} />
            </span>

            {courseDropdown && (
              <div className="pl-8 flex flex-col gap-2 mt-2">
                <span className={`text-[#e6eaec] cursor-pointer py-1 px-2 rounded hover:text-[#22BEFF] ${active === "course" ? "bg-[#22BEFF] text-black" : ""}`} onClick={() => setActive("course")}>
                  Course
                </span>
                {/* <span className={`text-[#e6eaec] cursor-pointer py-1 px-2 rounded hover:text-[#22BEFF] ${active === "submitted" ? "bg-[#22BEFF] text-black" : ""}`} onClick={() => setActive("submitted")}>
                  Submitted
                </span>
                <span className={`text-[#e6eaec] cursor-pointer py-1 px-2 rounded hover:text-[#22BEFF] ${active === "graded" ? "bg-[#22BEFF] text-black" : ""}`} onClick={() => setActive("graded")}>
                  Graded
                </span> */}
              </div>
            )}
          </div>
          {/* My Assignments with Dropdown */}
           {/* <div>
            <span
              className={`flex items-center justify-between gap-2 text-[#e6eaec] py-3 px-4 rounded-md cursor-pointer ${["assignment", "pending", "submitted", "graded"].includes(active) ? "bg-[#22BEFF] text-black" : "hover:text-[#22BEFF]"}`}
              onClick={() => setAssignmentDropdown(!assignmentDropdown)}
            >
              <div className="flex items-center gap-2">
                <IoIosBook />
                Assignments
              </div>
              <FaAngleDown className={`transition-transform duration-300 ${assignmentDropdown ? "rotate-180" : ""}`} />
            </span>

            {assignmentDropdown && (
              <div className="pl-8 flex flex-col gap-2 mt-2">
                <span className={`text-[#e6eaec] cursor-pointer py-1 px-2 rounded hover:text-[#22BEFF] ${active === "pending" ? "bg-[#22BEFF] text-black" : ""}`} onClick={() => setActive("pending")}>
                  Pending
                </span>
                <span className={`text-[#e6eaec] cursor-pointer py-1 px-2 rounded hover:text-[#22BEFF] ${active === "submitted" ? "bg-[#22BEFF] text-black" : ""}`} onClick={() => setActive("submitted")}>
                  Submitted
                </span>
                <span className={`text-[#e6eaec] cursor-pointer py-1 px-2 rounded hover:text-[#22BEFF] ${active === "graded" ? "bg-[#22BEFF] text-black" : ""}`} onClick={() => setActive("graded")}>
                  Graded
                </span>
              </div>
            )}
          </div> */}
          {/* My Academy with Dropdown */}
           <div>
            <span
              className={`flex items-center justify-between gap-2 text-[#e6eaec] py-3 px-4 rounded-md cursor-pointer ${["category", "pending", "submitted", "graded"].includes(active) ? "bg-[#22BEFF] text-black" : "hover:text-[#22BEFF]"}`}
              onClick={() => setacademyDropdown(!academyDropdown)}
            >
              <div className="flex items-center gap-2">
                <IoIosBook />
                Academy
              </div>
              <FaAngleDown className={`transition-transform duration-300 ${academyDropdown ? "rotate-180" : ""}`} />
            </span>

            {academyDropdown && (
              <div className="pl-8 flex flex-col gap-2 mt-2">
                <span className={`text-[#e6eaec] cursor-pointer py-1 px-2 rounded hover:text-[#22BEFF] ${active === "category" ? "bg-[#22BEFF] text-black" : ""}`} onClick={() => setActive("category")}>
                  Category
                </span>
                <span className={`text-[#e6eaec] cursor-pointer py-1 px-2 rounded hover:text-[#22BEFF] ${active === "evaluation" ? "bg-[#22BEFF] text-black" : ""}`} onClick={() => setActive("evaluation")}>
                  Evaluation
                </span>
                
                <span className={`text-[#e6eaec] cursor-pointer py-1 px-2 rounded hover:text-[#22BEFF] ${active === "book" ? "bg-[#22BEFF] text-black" : ""}`} onClick={() => setActive("book")}>
                  Book
                </span>
              </div>
            )}
          </div>

          <span className={`flex items-center gap-2 text-[#e6eaec] py-3 px-4 rounded-md cursor-pointer ${active === "appointment" ? "bg-[#22BEFF] text-black" : "hover:text-[#22BEFF]"}`} onClick={() => setActive("appointment")}>
            <VscAccount />
            Appointments
          </span>
          <span className={`flex items-center gap-2 text-[#e6eaec] py-3 px-4 rounded-md cursor-pointer ${active === "payment" ? "bg-[#22BEFF] text-black" : "hover:text-[#22BEFF]"}`} onClick={() => setActive("payment")}>
            <VscAccount />
            Payment
          </span>

          {/* <span className={`flex items-center gap-2 text-[#e6eaec] py-3 px-4 rounded-md cursor-pointer ${active === "support" ? "bg-[#22BEFF] text-black" : "hover:text-[#22BEFF]"}`} onClick={() => setActive("support")}>
            <BiSupport />
            Support
          </span> */}
        </div>
      </div>

      {/* main content area */}
      <div className="w-full min-h-screen flex flex-col gap-4">
        {/* top header */}
        <div className="w-full p-4 bg-[#00294B] flex items-center justify-between rounded-md">
          <div className="flex items-center gap-4">
            <div className="relative group p-2 bg-[#22BEFF] rounded-md w-[2.5rem] h-[2.2rem] cursor-pointer flex justify-center items-center" onClick={() => setManu(!menu)}>
              <CiMenuBurger className="absolute transition-opacity duration-300 group-hover:opacity-0 text-xl" />
              <FaArrowRight className="absolute opacity-0 group-hover:opacity-100 transition-all duration-300 transform group-hover:rotate-180 text-xl" />
            </div>

            <div className="lg:block hidden">
              <form className="flex gap-2 items-center py-1 px-2 border border-[#00294B] bg-[#101E2B] rounded-md focus-within:border-[#22BEFF]">
                <input type="text" placeholder="Search.." className="w-full py-1 text-[#e6eaec] border-none outline-0" />
                <span className="text-[#e6eaec] cursor-pointer">
                  <CiSearch />
                </span>
              </form>
            </div>
          </div>

          {/* right profile and notifications */}
          <div className="flex items-center gap-4">
            <div className="border border-[#254635] rounded-md flex justify-center items-center">
              <span className="text-[#22BEFF] p-2">
                <FaWhatsapp />
              </span>
            </div>

            <div className="border border-[#254635] rounded-md flex justify-center items-center bg-[#063B48]">
              <span className="text-white p-2">
                <HiOutlineBellAlert />
              </span>
            </div>

            <div className="flex items-center gap-2 cursor-pointer relative">
              <div className="w-[2.5rem] h-[2.5rem] bg-black rounded-full text-white flex justify-center items-center relative">
                <FaRegUser className="text-xl" />
                <div className="w-[0.7rem] h-[0.7rem] rounded-full bg-[#22BEFF] absolute bottom-0 right-0"></div>
              </div>

              <div className="flex gap-1 items-center" onClick={() => setProfileModal(!profileModal)}>
                <div className="flex flex-col gap-0">
                  <span className="text-base font-bold text-white">{user?.name}</span>
                  <span className="text-sm font-normal text-[#22BEFF]">student</span>
                </div>
                <span className="text-white">
                  <FaAngleDown />
                </span>
              </div>

              {profileModal && (
                <div className="absolute top-[4rem] right-0 w-[13rem] border border-[#22BEFF] p-4 rounded bg-[#00294B] flex flex-col gap-3 z-50">
                  <span className="text-white text-base font-normal flex items-center gap-2 hover:text-[#22BEFF] cursor-pointer">
                    <CgProfile /> Profile
                  </span>
                  <span className="text-white text-base font-normal flex items-center gap-2 hover:text-[#22BEFF] cursor-pointer">
                    <IoSettingsOutline /> Settings
                  </span>
                  <span onClick={handleLogout} className="text-white text-base font-normal flex items-center gap-2 hover:text-[#22BEFF] cursor-pointer">
                    <CiLogout /> Logout
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* main render content */}
        <div className="w-full mt-[1rem]">
          {renderComponent()}
        </div>
      </div>
    </div>
  );
};

export default GuestDashboard;
